import { useContext, useId } from 'react'
import { MarkupContext } from '../../providers/Markup'
import { transformPaddingToTailwind } from '../../helpers/style'
import { hasRenderableText } from '../../helpers/markup'
import Section from './_Section'

function InformationBox(props) {
  const { createMarkup } = useContext(MarkupContext)
  const titleId = useId()
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  const showTitle = hasRenderableText(props.title)
  const showContent = hasRenderableText(props.content)

  if (!showTitle && !showContent) {
    return null
  }

  const titleMarkup = showTitle ? createMarkup(props.title) : undefined
  const contentMarkup = showContent ? createMarkup(props.content) : undefined

  return (
    <Section
      type="informationBox"
      idx={props.idx}
      outerClass={componentPadding ?? ''}
      sectionTitle={false}
      aria-labelledby={showTitle ? titleId : undefined}
    >
      <div
        className="rounded-sm p-6 md:py-7 md:px-8 bg-(--sb-secondary-light-tint-blue)"
        style={props.backgroundColor ? { '--sb-secondary-light-tint-blue': props.backgroundColor } : undefined}
      >
        {showTitle && (
          <h2
            id={titleId}
            className="font-bold text-lg leading-[1.4] mt-0 mb-[0.625rem] text-(--sb-common-base-body-text-color)"
            data-rte="true"
            dangerouslySetInnerHTML={titleMarkup}
          />
        )}
        {showContent && (
          <div
            className="text-lg leading-normal m-0 text-(--sb-common-base-body-text-color)"
            data-type="information-box-content"
            data-rte="true"
            dangerouslySetInnerHTML={contentMarkup}
          />
        )}
      </div>
    </Section>
  )
}

export default InformationBox
